import { Sanity$AccordionFAQ } from '@otovo/shared/types/sanityTypes';
import { RowContext } from './types';

export function createRowContext(
  index: number,
  rowContext: {
    faqItems?: Sanity$AccordionFAQ[];
  },
  storefrontV2Enabled: boolean = false,
): RowContext {
  if (storefrontV2Enabled) {
    // In v2, we don't use the white color scheme.
    return {
      isWhiteRow: false,
      rowIndex: index,
      ...rowContext,
    };
  }
  const isWhiteRow = index % 2 !== 0;

  const context: RowContext = {
    isWhiteRow,
    rowIndex: index,
    ...rowContext,
  };

  return context;
}
